import { useContext } from 'react';
import { useValidateDraftCondition } from '../../hooks/useValidateDraftCondition';
import { useViewerActions } from '../../hooks/useViewerActions';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import LogicGroupsDivider from '../common/LogicGroupsDivider';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerAddGroup = () => {
  const {
    internalDraftValue,
    draftCondition,
    isInEditMode,
    props: {
      isAndGroup,
      isReadOnly,
      editButtonsState,
      uiMessages: {
        viewerEmptyFilters,
        addFilterButtonLabel,
        addFilterGroupButtonLabel
      },
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onAddFilterGroup,
    onAddFirstFilterGroup
  } = useViewerActions();
  const {
    validateDraftCondition
  } = useValidateDraftCondition();
  const {
    disabled: isEditButtonDisabled,
    tooltipHeadingText,
    tooltipTitle
  } = editButtonsState || {};
  const alreadyHasGroups = !!internalDraftValue && internalDraftValue.conditions.size > 0;
  if (isReadOnly || alreadyHasGroups && (isAndGroup || !isInEditMode || useOnePanel)) {
    return null;
  }
  const isEditorOpen = Boolean(draftCondition);
  const onAddFilterGroupClicked = () => {
    if (isEditorOpen) {
      validateDraftCondition();
    }
    onAddFilterGroup();
  };
  const isCurrentlyAddingNewGroup = Boolean(draftCondition && draftCondition.isAddingNew);
  if (alreadyHasGroups) {
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(LogicGroupsDivider, {
        logicOperator: internalDraftValue.logicGroupName
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: !isCurrentlyAddingNewGroup,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.disabledAddGroupTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          "data-selenium-info": "Or",
          "data-selenium-test": "fr-viewer-add-filter-btn",
          disabled: isCurrentlyAddingNewGroup,
          onClick: onAddFilterGroupClicked,
          size: "sm",
          use: "tertiary-light",
          responsive: false,
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterGroupButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "newCustomerDataFilters.filtersViewer.addGroup"
            })]
          })
        })
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      paddingBlockStart: "250",
      children: [/*#__PURE__*/_jsx("p", {
        children: viewerEmptyFilters || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.emptyStateMessage"
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: !isEditButtonDisabled,
        headingText: tooltipHeadingText,
        placement: "bottom",
        title: tooltipTitle,
        use: "longform",
        children: /*#__PURE__*/_jsxs(Button, {
          "data-onboarding": "add-filter-btn",
          "data-selenium-info": "Or",
          "data-selenium-test": "fr-viewer-add-filter-btn",
          disabled: isEditButtonDisabled,
          onClick: onAddFirstFilterGroup,
          size: "sm",
          use: "tertiary",
          responsive: false,
          children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.addFilter"
          })]
        })
      })]
    });
  }
};
export default ViewerAddGroup;